import React from 'react';
import { DISTANCE_OPTIONS } from '../../../../../constants/index';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';
export const DistanceFilter = ({ value, onChange, ...otherProps }) => {
  const selectedValue = DISTANCE_OPTIONS.filter((e) => e.value === value)[0];
  return (
    <AutoSuggestionSelectComponent
      placeholder="Distance"
      options={DISTANCE_OPTIONS}
      components={{ IndicatorSeparator: () => null }}
      value={selectedValue ? selectedValue : null}
      onChange={onChange}
      {...otherProps}
      isSearchable={false}
      inputClassName="best-match-filter height-32"
    />
  );
};
